import { Product } from '~shared/models';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';
import { Ga4TrackingHelpersService } from '~shared/modules/ga-tracking/utils';
import { PriceTypes } from '~shared/modules/price-type-toggler/price-type-toggler.module';
import { GaTrackingCheckoutService } from '../../utils/ga-tracking-checkout.service';
import { GATrackingEvent } from '~shared/modules/ga-tracking/models';

export class GaTrackingSelectItemEventModel implements GATrackingEvent {
  isGA4: boolean = true;
  constructor(
    private pageName: string,
    private product: Product,
    private priceType: PriceTypes,
    private productIndex: number,
    private colorVariantId?: string,
    private searchTerm?: string
  ) {
    GaTrackingCheckoutService.setItemSelectionPage(product.id, pageName);
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.SelectItem;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.getEventType(),
      gtmCustom: {
        ecommerce: {
          search_term: this.searchTerm,
          item_list_name: this.pageName,
          items: [
            Ga4TrackingHelpersService.getGA4ItemObject(
              this.product,
              this.priceType,
              this.productIndex,
              this.colorVariantId
            ),
          ],
        },
      },
    };
  }
}
